import styled from 'styled-components';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';
import { screen } from '@/helpers/screen';

export const CardWrapper = styled.article`
  display: flex;
  flex-direction: column;
  padding: 32px 28px 20px;
  border: 1px solid rgb(${getToken('color-background-tertiary')});
  border-radius: 16px;
  background: rgb(${getToken('color-background-secondary')});

  [data-alt] & {
    background: #fff;
  }
`;

export const CardTitle = styled.h3`
  font: 700 20px/1.4 ${getToken('font-family-default')};
  color: rgb(${getToken('color-primary-60')});
  margin: 0 0 8px;
`;

export const CardTagline = styled.p`
  font: 700 16px/1.6 ${getToken('font-family-default')};
  color: rgb(${getToken('color-text-primary')});
  margin: 0 0 6px;
`;

export const CardCopy = styled.p`
  font: 400 16px/1.6 ${getToken('font-family-default')};
  color: rgb(${getToken('color-neutral-90')});
  margin: 0 0 12px;

  a {
    color: inherit;
    text-decoration: underline;
    text-underline-offset: 3px;
  }
`;

export const SrOnly = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export const CardLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  margin-top: auto;
  padding-top: 14px;
  font: 700 16px/1.3 ${getToken('font-family-default')};
  color: rgb(${getToken('color-primary-60')});
  text-decoration: none;

  svg {
    display: block;
    transition: transform 0.15s;
  }

  &:hover {
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  &:hover svg {
    transform: translateX(3px);
  }
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  margin-top: var(--gap-h2, 56px);

  ${screen.md} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  ${screen.lg} {
    grid-template-columns: repeat(${({ $cols }) => $cols || 3}, minmax(0, 1fr));
  }

  ${({ $cols }) =>
    $cols === 4 &&
    `
        ${CardWrapper} {
            padding: 28px 24px 16px;
        }

        ${CardTitle} {
            min-height: 2.8em;
        }
    `}
`;
